<template>
  <b-row align-v="center">
    <b-col>
      <div v-if="!value">{{ label }}</div>
      <ul v-else class="list-file">
        <li>
          <span>{{ value.originalname || value.name }}</span>
          <button class="btn-link" @click="$emit('input', null)">
            <i class="icon-close fs10 pl-10"></i>
          </button>
        </li>
      </ul>
    </b-col>
    <b-col v-if="!value" cols="auto" class="text-right">
      <label class="file-select">
        <div class="btn btn-sm btn-outline mt-4 select-button">
          <i class="icon-plus text-blue-900 fs13 pr-10"></i
          ><span>Select file</span>
        </div>

        <input
          ref="file"
          type="file"
          data-vv-as="file"
          :accept="accept"
          @change="onChange"
        />
      </label>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    type: {
      required: true,
      type: String
    },
    label: String
  },
  computed: {
    accept() {
      return this.type === 'video'
        ? 'video/mp4,video/x-m4v,video/x-matroska,video/webm,video/quicktime,video/*'
        : 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-powerpoint'
    }
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0]

      if (!file) {
        return
      }

      this.$emit('input', file)

      e.target.value = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.file-select > .select-button {
  cursor: pointer;
}

/* Don't forget to hide the original file input! */
.file-select > input[type='file'] {
  display: none;
}
</style>
